import React from 'react';
import ScheduleList from '../components/ScheduleList';
import AdminLayout from 'cms/core/shared/AdminLayout';
import { Box, Typography, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

function ScheduleScreen() {
  return (
    <AdminLayout pageTitle="Schedules">
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <MuiLink component={Link} to="/cms" color="inherit">
            Home
          </MuiLink>
          <MuiLink component={Link} to="/cms/settings" color="inherit">
            Settings
          </MuiLink>
          <Typography color="text.primary">Schedules</Typography>
        </Breadcrumbs>
        <Typography variant="h4" fontWeight={700} gutterBottom color="text.primary">
          Schedules
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Manage work schedule types and classifications
        </Typography>
      </Box>
      <ScheduleList />
    </AdminLayout>
  );
}

export default ScheduleScreen;

